module.exports = __webpack_public_path__ + "media/images/peb/8mm/peb_g-30a73e57b914ea63583658c2c08cffee.png";